import styled from 'styled-components';

export const DiscountListComponentContainer = styled.section`
    .discounts .discount {
        &:not(:last-child) {
            margin: 0 0 15px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/DiscountsListComponentStyle.js